export const LEGAL_DOCUMENT_VERSION = "1.0";
export const LEGAL_LAST_UPDATED = "24.07.2026";
export const SUPPORT_EMAIL = "support@hockeyplanner.ru";
export const PRODUCT_NAME = "Hockey Planner";
